// Shared "bride first" ordering for a customer's contacts.
//
// Wherever a display name is built from a customer's contacts (event names,
// meeting titles, task names) we want the bride (כלה) to come before the
// groom (חתן). Contact titles are seeded per tenant as id 1 = 'כלה' (bride)
// and id 2 = 'חתן' (groom) — see apiv2 tenants.service.ts. A contact's `title`
// shows up in two shapes across the app: sometimes the joined title object
// ({ id, name }), sometimes a bare title id — so we match on either.

const BRIDE_TITLE_ID = 1;
const GROOM_TITLE_ID = 2;
const BRIDE_TITLE_NAME = 'כלה';
const GROOM_TITLE_NAME = 'חתן';

function titleIdOf(contact) {
    if (!contact || contact.title == null)
        return null;

    // title can be the joined object { id, name } or a bare id
    if (typeof contact.title === 'object')
        return contact.title.id != null ? contact.title.id : null;

    return contact.title;
}

function titleNameOf(contact) {
    if (contact && contact.title && typeof contact.title === 'object')
        return contact.title.name;

    return null;
}

export function isBrideContact(contact) {
    return titleIdOf(contact) == BRIDE_TITLE_ID || titleNameOf(contact) === BRIDE_TITLE_NAME;
}

export function isGroomContact(contact) {
    return titleIdOf(contact) == GROOM_TITLE_ID || titleNameOf(contact) === GROOM_TITLE_NAME;
}

// Returns a NEW array with brides first, then grooms, then everyone else,
// preserving the original relative order within each group (stable). Safe to
// call with a null/undefined/non-array value (returns an empty array).
export function orderContactsBrideFirst(contacts) {
    if (!Array.isArray(contacts))
        return [];

    const brides = [];
    const grooms = [];
    const others = [];

    contacts.forEach(contact => {
        if (isBrideContact(contact))
            brides.push(contact);
        else if (isGroomContact(contact))
            grooms.push(contact);
        else
            others.push(contact);
    });

    return brides.concat(grooms).concat(others);
}
